import * as yup from "yup";

export const multiplierSchema = yup
  .number()
  .typeError("Multiplier must be a number")
  .moreThan(0, "Multiplier must be more than 0")
  .max(19.99, "Multiplier may not exceed 19.99")
  .required("Multiplier is required");
